import { render, staticRenderFns } from "./ItsOrderHaulageAbroad.vue?vue&type=template&id=82559cf0&scoped=true&"
import script from "./ItsOrderHaulageAbroad.vue?vue&type=script&lang=js&"
export * from "./ItsOrderHaulageAbroad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82559cf0",
  null
  
)

export default component.exports